/* eslint-disable import/no-unresolved */
/* eslint-disable react/no-children-prop */
/* eslint-disable no-tabs */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useRef, useState } from "react";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { useReactToPrint } from "react-to-print";
import DocumentationDropdown from "shared-components/lib/documentation/documentation_dropdown";
import DocumentationLink from "shared-components/lib/documentation/documentation_link";
import ExportLink from "shared-components/lib/documentation/export_link";
import { STEPS } from "../../../../store/data/commonData";
import {
  selectConfigurationType,
  selectEventsData,
  selectUpdatingConfiguration
} from "../../../../store/slices/common";
import { CARTESIAN, getCurrentConfiguration } from "../../../../utils/api/common";
import { gatherCartesianProductsForBOM } from "../../../../utils/Cartesian/func.utils";
import { exportHiveFileXML, exportHiveFileZIP, exportXls, logEvent } from "../../../../utils/common/api/api";
import {
  buildAddToCartDataLayerEvent,
  buildFileDownloadDataLayerEvent,
  logDataLayerEvent
} from "../../../../utils/common/dataLayerAnalytics/dataLayerAnalytics";
import t from "../../../../utils/common/translation/translator";
import useCheckMobileScreen from "../../../../utils/common/useCheckMobileScreen";
import { gatherMc12ProductsForBOM } from "../../../../utils/Mc12/func.utils";
import { gatherRetrofitProductsForBOM } from "../../../../utils/Retrofit/func.util";
import CustomPopup from "../../CustomPopup/CustomPopup";
import PrintPageContent from "../PrintablePageContent/PrintPageContent";

const ActionLinks = () => {
  const configuration = getCurrentConfiguration();
  const configurationType = useSelector(selectConfigurationType);
  const eventsData = useSelector(selectEventsData);
  const updatingConfiguration = useSelector(selectUpdatingConfiguration);
  const componentRef = useRef(null);

  const isMobile = useCheckMobileScreen();

  const {
    refetch: execExportXls,
    isLoading: isLoadingExport,
    isFetching: isFetchingExport
  } = useQuery(
    "Export BOM in XLS",
    async () => {
      if (updatingConfiguration) {
        return undefined;
      }
      try {
        const exportUri = await exportXls(configuration.configId, configurationType);
        return exportUri;
      } catch (error) {
        console.error(error.response?.status);
      }
      return undefined;
    },
    {
      enabled: false
    }
  );

  const handleBuildFileDownloadDataLayerEvent = (documentName, extension) => {
    logDataLayerEvent(buildFileDownloadDataLayerEvent(documentName, extension));
  };

  const handleExportCadEvent = () => {
    buildFileDownloadDataLayerEvent("EXPORT_CAD", ".cad");
  };

  const {
    refetch: execExportHiveFileXML,
    isLoading: isLoadingExportHiveFileXML,
    isFetching: isFetchingExportHiveFileXML
  } = useQuery(
    "Export HiveFile as XML",
    async () => {
      if (updatingConfiguration) {
        return undefined;
      }
      try {
        const exportUri = await exportHiveFileXML(configuration.configId, configurationType, "yes");
        return exportUri;
      } catch (error) {
        console.error(error.response?.status);
      }
      return undefined;
    },
    {
      enabled: false
    }
  );

  const [cadPopupOpened, setCadPopupOpened] = useState(false);

  const downloadCad = () => {
    logEvent(eventsData.locale, eventsData.types.exportCAD, eventsData.tags.finalizeStep, configuration?.configId);
    setCadPopupOpened(true);
    handleExportCadEvent();
  };

  const {
    refetch: execExportHiveFileZIP,
    isLoading: isLoadingExportHiveFileZIP,
    isFetching: isFetchingExportHiveFileZIP
  } = useQuery(
    "Export HiveFile as Zip",
    async () => {
      if (updatingConfiguration) {
        return undefined;
      }
      try {
        const exportUri = await exportHiveFileZIP(configuration.configId, configurationType, "yes");
        return exportUri;
      } catch (error) {
        console.error(error.response?.status);
      }
      return undefined;
    },
    {
      enabled: false
    }
  );

  const exportLinks = [];

  exportLinks.push(
    <ExportLink
      key={1}
      name={t("msizer.ui.export_bill_of_materials")}
      loading={isLoadingExport || isFetchingExport}
      onDownload={async () => {
        // analytics
        logEvent(eventsData.locale, eventsData.types.exportXLS, eventsData.tags.finalizeStep, configuration?.configId);
        // data layer
        var products = [];
        switch (configuration?.configData?.configurationType) {
          case "MC12":
            const { track } = configuration?.configData;
            products = gatherMc12ProductsForBOM(track);
            break;
          case "CARTESIAN":
            products = await gatherCartesianProductsForBOM(configuration.configId);
            break;
          case "INTEGRATED_DRIVES":
            products = [];
            break;
          default:
            const { axes } = configuration?.configData;
            products = gatherRetrofitProductsForBOM(axes);
        }

        const steps = STEPS?.[configuration.configData.configurationType];
        const stepsArray = Object.values(steps).flat();
        const currentStepIndex = stepsArray.findIndex((step) => step.id === configuration.configData.currentStepId);
        const currentStepName = currentStepIndex > -1 ? stepsArray[currentStepIndex].label : "";

        logDataLayerEvent(
          buildAddToCartDataLayerEvent(
            {
              id: configuration.configId,
              name: configuration.configData?.configName,
              step: currentStepName
            },
            "EXPORT_XLS",
            products
          )
        );
        execExportXls();
      }}
      extensionLabel=".xls"
    />
  );
  if (configurationType.toLowerCase() === CARTESIAN.toLowerCase()) {
    exportLinks.push(
      <ExportLink
        name={t("msizer.ui.export_hivefile")}
        loading={isLoadingExportHiveFileXML || isFetchingExportHiveFileXML}
        onDownload={() => {
          logEvent(
            eventsData.locale,
            eventsData.types.exportHiveFile,
            eventsData.tags.finalizeStep,
            configuration?.configId
          );
          handleBuildFileDownloadDataLayerEvent("EXPORT_HIVE_FILE", ".xml");
          execExportHiveFileXML();
        }}
        extensionLabel=".xml"
      />
    );
  }

  // if (configurationType.toLowerCase() === "mc12") {
  //   exportLinks.push(
  //     <ExportLink
  //       name={t("msizer.ui.export_track")}
  //       loading={false}
  //       onDownload={() => {
  //         const storedData = localStorage.getItem("exported3D");
  //         downloadGLTF(storedData, configuration.configId);
  //       }}
  //       extensionLabel=".gltf"
  //     />
  //   );
  // }

  if (configurationType.toLowerCase() === "integrated_drives") {
    exportLinks.push(
      <ExportLink
        name={t("msizer.ui.export_hivefile")}
        loading={isLoadingExportHiveFileZIP || isFetchingExportHiveFileZIP}
        onDownload={() => {
          logEvent(
            eventsData.locale,
            eventsData.types.exportHiveFile,
            eventsData.tags.finalizeStep,
            configuration?.configId
          );
          handleBuildFileDownloadDataLayerEvent("EXPORT_HIVE_FILE", ".zip");
          execExportHiveFileZIP();
        }}
        extensionLabel=".zip"
      />
    );
  }

  if (configurationType.toLowerCase() === CARTESIAN.toLowerCase()) {
    exportLinks.push(
      <>
        <DocumentationLink
          key={2}
          name={t("msizer.ui.print")}
          onDownload={() => null}
          documentGroup={new Map()}
          getLabel={(key) => t(`msizer.ui.${key}`)}
        />
        <ExportLink key={2} name={t("msizer.ui.cad")} onDownload={() => downloadCad()} />
      </>
    );
  } else {
    exportLinks.push(
      <ExportLink
        key={2}
        name={t("msizer.ui.print")}
        onDownload={useReactToPrint({
          content: () => componentRef.current
        })}
      />
    );
  }

  console.log("cadenasProductCode", configuration?.configData?.cadenasProductCode);

  return (
    <>
      <PrintPageContent ref={componentRef} />
      <DocumentationDropdown
        title={t("msizer.ui.export_as") + " (" + exportLinks?.length + ")"}
        children={exportLinks}
        defaultOpenStatus={!isMobile}
      />
      <CustomPopup
        wideWidth
        opened={cadPopupOpened}
        onClose={() => !updatingConfiguration && setCadPopupOpened(false)}
        // title={
        //   configuration.configData.cadenasCode +
        //   " .... " +
        //   configuration.configData.cadenasCode?.replace(/\+/g, "%2B")?.replace(/ /g, "%20")
        // }
      >
        <div className={`relative ${updatingConfiguration ? "pointer-events-none opacity-50" : ""}`}>
          <iframe
            title="CAD"
            src={`https://schneider-electric-motion-embedded.partcommunity.com/?catalog=berger_lahr&part=${configuration?.configData?.cadenasProductCode
              ?.replace(/\+/g, "%2B")
              ?.replace(/ /g, "%20")}&hidePortlets=navigation&hidePortlets=search&showPortlets=generation`}
            frameborder="0"
            height="800px"
            width="100%"
          ></iframe>
        </div>
      </CustomPopup>
    </>
  );
};

export default ActionLinks;

// PAS41BRM1000A2NAxxxR/21G0H70 + PLE60 (3:1) + BMH0701xxxA2A

// PAS42BRM1000A4NAXXXR/21A3H79 + WPLE60 (3:1) + BMH0701P06A2A

// PAS42BRM1000A4NAxxxR/21A3H79%20%2B%20WPLE60%20(3:1)%20%2B%20BMH0701P06A2A

// PAS41BRM1000A2NAxxxR/21G0H70%20%2B%20PLE60%20(3:1)%20%2B%20BMH0701xxxA2A
